import { Box, Paper, styled, Typography, Select, FormControl, Checkbox } from '@mui/material';
import { MaterialCalendarPicker } from 'components/Inputs/MaterialCalendarPicker';

export const IconWrapper = styled(Box)(({ theme, color }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  "& .MuiSvgIcon-root": {
    color: color,
  },
}))

export const StepIndicator = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 16,
})

export const StepDotInner = styled(Box)({
  height: 6,
  width: 6,
  borderRadius: "50%",
  backgroundColor: "#4caf50",
})

export const DaysSection = styled(Box)(({ theme }) => ({
  borderLeft: "4px solid #5c6bc0",
  paddingLeft: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(3),
}))

export const SearchEngineBox = styled(Paper)(({ theme }) => ({
  backgroundColor: "#f5f8ff",
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  borderLeft: "4px solid #2196f3",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.12)",
  }
}))

export const StyledCalendarPicker = styled(MaterialCalendarPicker)`
    width: 100%;
`

// Adding new styled components for FirstStep.tsx

export const MainContainer = styled(Box)`
  background-color: #fff;
  min-height: 100vh;
  min-height: 100dvh; /* Use dynamic viewport height for better mobile support */
  padding-bottom: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  /* Ensure smooth scrolling on all devices */
  -webkit-overflow-scrolling: touch;
`;

export const ContentContainer = styled(Box)`
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
  padding-top: 32px;
  padding-bottom: 120px; /* Increased from default to ensure button accessibility */
  
  /* Responsive padding for different screen sizes */
  @media (max-width: 600px) {
    padding: 12px;
    padding-top: 24px;
    padding-bottom: 140px; /* Extra padding on mobile for safe area */
  }
  
  @media (max-height: 700px) {
    /* For shorter screens, reduce top padding but maintain bottom padding */
    padding-top: 16px;
    padding-bottom: 120px;
  }
`;

export const HeaderPaper = styled(Paper)`
  background: transparent;
  box-shadow: none;
  border: none;
`;

export const HeaderTitle = styled(Typography)`
  font-weight: bold;
  color: var(--primary-blue);
  font-size: 1.3rem;
  margin-bottom: 16px;
  text-align: start;
  
  @media (min-width: 900px) {
    font-size: 1.5rem;
  }
`;

export const StepDot = styled(Box)`
  width: 10px;
  height: 10px;
  background-color: #4CAF50;
  border-radius: 50%;
  display: inline-block;
`;

export const StepText = styled(Typography)`
  margin-left: 8px;
  font-weight: 500;
`;

export const ProgressBarContainer = styled(Box)`
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  margin-bottom: 32px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
`;

export const ProgressBar = styled(Box)`
  position: absolute;
  height: 100%;
  background-color: var(--primary-blue);
  border-radius: 8px;
`;

export const FieldsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FieldContainer = styled(Box)``;

export const IconBadge = styled(Box)`
  font-size: 1.5rem;
  padding: 4px;
  background-color: #f0f7ff;
  border-radius: 8px;
`;

export const SectionTitle = styled(Typography)`
  font-weight: 500;
  font-size: 1rem;
`;

export const StyledSelect = styled(Select)`
  border-radius: 4px;
  
  & .MuiOutlinedInput-notchedOutline {
    border-color: #e0e0e0;
  }
`;

export const DaysSelectionBox = styled(Box)`
  background-color: #f5f8ff;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
`;

export const DaysTitle = styled(Typography)`
  font-weight: 500;
  margin-bottom: 16px;
`;

export const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

export const StyledCheckbox = styled(Checkbox)`
  color: var(--primary-blue);
  &.Mui-checked {
    color: var(--primary-blue);
  }
`;

export const SkillsContainer = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const EmailInfoText = styled(Typography)`
  font-size: 0.9rem;
`;

export const EmailTextField = styled(Box)`
  margin-top: 16px;
  
  & .MuiOutlinedInput-root {
    border-radius: 4px;
  }
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

export const ContinueButton = styled('button')`
  background-color: var(--primary-blue);
  border-radius: 40px;
  padding: 12px 0;
  text-transform: uppercase;
  font-weight: bold;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  
  &:hover {
    background-color: #002266;
  }
`;

export const CancelButton = styled('button')`
  color: var(--primary-blue);
  background: none;
  border: none;
  cursor: pointer;
  text-transform: none;
  padding: 8px 0;
  
  &:hover {
    text-decoration: underline;
  }
`;